import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3919939449/src/next-app/app/(authenticated)/client.tsx");
